import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinnarolgidc() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Narol GIDC Ahmedabad',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Narol GIDC Ahmedabad',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Narol GIDC Ahmedabad, catering to the transportation needs of industrial units, manufacturing plants, warehouses, and corporate offices in the region. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, supervisors, clients, and senior executives. Whether it is daily staff commute, industrial visits, airport transfers, business meetings, inter-office travel, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental packages, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a dependable and premium corporate travel experience for businesses operating in and around Narol GIDC Ahmedabad.',

    top: 'Top Places to Visit in Ahmedabad with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Sabarmati Ashram",
    "description": "Sabarmati Ashram, located on the banks of the Sabarmati River, was the home of Mahatma Gandhi for over a decade and served as a major center for the Indian freedom movement. Visitors can explore Gandhi’s simple living quarters, archives of letters, photographs, and exhibits explaining India’s struggle for independence. The peaceful environment, museum, and historical displays make it a place of deep reflection and national pride."
  },
  {
    "title": "Sidi Saiyyed Mosque",
    "description": "The Sidi Saiyyed Mosque, built in 1573 during the Gujarat Sultanate period, is renowned for its iconic stone latticework windows known as the 'Sidi Saiyyed Jali'. These intricately carved screens depicting the famous ‘Tree of Life’ are considered masterpieces of Indo-Islamic art. The mosque offers visitors a chance to admire historic craftsmanship and experience one of Ahmedabad’s most recognized architectural symbols."
  },
  {
    "title": "Sabarmati Riverfront",
    "description": "Sabarmati Riverfront is a beautiful riverside development project that has transformed Ahmedabad’s waterfront into a vibrant public space. Featuring pedestrian walkways, gardens, cycling tracks, boating facilities, and event spaces, the riverfront is ideal for family outings, leisure walks, and evening relaxation. The well-maintained urban landscape and scenic views make it a preferred hangout spot for locals and tourists."
  },
  {
    "title": "Adalaj Stepwell",
    "description": "Adalaj Stepwell, located just outside Ahmedabad, is a centuries-old five-story stepwell built in 1498 in Indo-Islamic architectural style. Known for its beautifully carved pillars, ornamental walls, and cooling subterranean design, the stepwell served as a resting place for travelers in earlier times. Today, it stands as an engineering and artistic marvel, offering visitors a glimpse into Gujarat’s architectural heritage."
  },
  {
    "title": "Kankaria Lake",
    "description": "Kankaria Lake is a large man-made lake that has evolved into one of Ahmedabad’s most popular recreational hubs. Surrounding the lake are amusement rides, toy trains, food stalls, a zoo, children’s play zones, and water activities, making it ideal for families. The illuminated musical fountain shows and clean walking paths make evenings at Kankaria lively and memorable."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, built in 1424 by Sultan Ahmed Shah, is one of the most impressive mosques in Gujarat. Constructed from yellow sandstone, it features beautifully carved pillars, grand prayer halls, and a harmonious blend of Hindu and Islamic architectural influences. Visitors can explore the expansive courtyard and admire the detailed stonework, reflecting the historical importance of early Ahmedabad."
  },
  {
    "title": "Calico Museum of Textiles",
    "description": "The Calico Museum of Textiles is one of the finest textile museums in the world, preserving centuries of India’s weaving, dyeing, printing, and embroidery traditions. Exhibits include royal costumes, temple cloths, carpets, and antique fabrics displayed in well-curated galleries. Visitors can gain a deep understanding of India's rich textile heritage, craftsmanship, and cultural evolution."
  },
  {
    "title": "Auto World Vintage Car Museum",
    "description": "Auto World Vintage Car Museum houses one of India’s largest collections of classic automobiles, including limousines, sports cars, convertibles, and royal vehicles from Europe and America. Many cars belonged to Indian princely families and are preserved in running condition. The museum offers a nostalgic journey into the history of automotive engineering and luxury travel."
  },
  {
    "title": "Hutheesing Jain Temple",
    "description": "Built in 1848, Hutheesing Jain Temple is a beautifully crafted marble temple dedicated to Lord Dharmanath. The temple features ornate carvings, elaborately decorated domes, and peaceful prayer halls that showcase the artistic traditions of Jain architecture. It is a serene spiritual destination and a remarkable example of Ahmedabad’s religious heritage."
  },
  {
    "title": "Manek Chowk",
    "description": "Manek Chowk is Ahmedabad’s famous city square known for its unique transformation throughout the day: a bustling vegetable market in the morning, a jewelry hub during the day, and a thriving street food destination at night. Visitors can enjoy traditional Gujarati snacks, sweets, and freshly prepared dishes, making it a must-visit spot for food lovers seeking authentic local flavors."
  }
],


"services": [
  {
    "name": "Narol GIDC Employee Transport Ahmedabad",
    "description": "Narol GIDC Employee Transport Ahmedabad provides reliable daily commute solutions for employees working in Narol GIDC. With dedicated vehicles, trained drivers, and GPS-enabled tracking, it ensures punctual, safe, and efficient transportation for factory and industrial staff."
  },
  {
    "name": "Corporate Shuttle Narol GIDC Ahmedabad",
    "description": "Corporate Shuttle Narol GIDC Ahmedabad delivers high-capacity shuttle services for organizations with large employee bases. Equipped with AC minibuses and optimized routes, it ensures timely pick-ups and drops, multi-shift support, and safe commuting within the industrial zone."
  },
  {
    "name": "Industrial Cab Narol GIDC Ahmedabad",
    "description": "Industrial Cab Narol GIDC Ahmedabad offers specialized transport for industrial and manufacturing employees. The service includes well-maintained vehicles, professional chauffeurs, and pre-planned routes to guarantee safe and reliable daily travel."
  },
  {
    "name": "Factory Staff Transport Narol Ahmedabad",
    "description": "Factory Staff Transport Narol Ahmedabad provides structured transportation for factory employees, featuring bulk shuttle options, scheduled routes, and trained drivers. It ensures consistent, safe, and punctual commuting for staff across Narol GIDC."
  },
  {
    "name": "Monthly Cab Narol GIDC Ahmedabad",
    "description": "Monthly Cab Narol GIDC Ahmedabad offers contract-based transport solutions for daily employee commuting. Services include dedicated vehicles, driver management, route optimization, and GPS tracking for uninterrupted, cost-effective monthly mobility."
  },
  {
    "name": "Business Cab Narol GIDC Ahmedabad",
    "description": "Business Cab Narol GIDC Ahmedabad provides executive travel solutions for meetings, site visits, and inter-office trips. Featuring sedans and SUVs with professional drivers, it ensures a comfortable, punctual, and professional travel experience for business personnel."
  },
  {
    "name": "Affordable Cab Narol GIDC Ahmedabad",
    "description": "Affordable Cab Narol GIDC Ahmedabad delivers budget-friendly corporate transport services without compromising on safety, punctuality, or comfort. Ideal for SMEs and mid-sized factories, it ensures reliable daily employee commuting."
  },
  {
    "name": "Best Corporate Cab Narol GIDC Ahmedabad",
    "description": "Best Corporate Cab Narol GIDC Ahmedabad offers premium transport with top-quality vehicles, professional chauffeurs, and high service standards. Suitable for executives and VIP staff, it provides a smooth and professional commuting experience."
  },
  {
    "name": "Outstation Cab Narol GIDC Ahmedabad",
    "description": "Outstation Cab Narol GIDC Ahmedabad provides long-distance travel services for corporate meetings, client visits, and factory tours. The service includes comfortable vehicles, experienced drivers, route planning, and live tracking for safe outstation trips."
  },
  {
    "name": "Sedan Cab Narol GIDC Ahmedabad",
    "description": "Sedan Cab Narol GIDC Ahmedabad offers executive sedans for managers and senior staff. With plush interiors and trained chauffeurs, it ensures a premium, comfortable, and safe commuting experience for daily and outstation travel."
  },
  {
    "name": "SUV Cab Narol GIDC Ahmedabad",
    "description": "SUV Cab Narol GIDC Ahmedabad provides spacious and durable SUVs for team travel, senior staff movement, and outstation trips. The service prioritizes comfort, safety, and reliability for corporate commuting needs."
  },
  {
    "name": "Company Transport Narol Ahmedabad",
    "description": "Company Transport Narol Ahmedabad delivers end-to-end fleet solutions for organizations in the industrial zone. It includes driver management, vehicle maintenance, route planning, and real-time tracking to ensure smooth, safe, and organized employee transport."
  },
  {
    "name": "Employee Mobility Narol GIDC Ahmedabad",
    "description": "Employee Mobility Narol GIDC Ahmedabad offers flexible, tech-enabled commuting solutions for employees, supporting multi-shift schedules, GPS tracking, and real-time fleet coordination to ensure seamless, reliable, and safe travel within Narol GIDC."
  },
  {
    "name": "Corporate Fleet Narol GIDC Ahmedabad",
    "description": "Corporate Fleet Narol GIDC Ahmedabad provides comprehensive fleet management solutions including sedans, SUVs, and shuttle vehicles. Services include vehicle maintenance, professional drivers, compliance tracking, and scalable fleet availability for industrial companies."
  },
  {
    "name": "Staff Pickup Drop Narol GIDC Ahmedabad",
    "description": "Staff Pickup Drop Narol GIDC Ahmedabad offers scheduled pick-up and drop-off services for employees. With fixed and flexible routes, real-time tracking, and professional chauffeurs, it ensures safe, punctual, and efficient staff transportation."
  }
],

"tableData": [
  ["Narol GIDC Employee Transport Ahmedabad", "Corporate Shuttle Narol GIDC Ahmedabad"],
  ["Industrial Cab Narol GIDC Ahmedabad", "Factory Staff Transport Narol Ahmedabad"],
  ["Monthly Cab Narol GIDC Ahmedabad", "Business Cab Narol GIDC Ahmedabad"],
  ["Affordable Cab Narol GIDC Ahmedabad", "Best Corporate Cab Narol GIDC Ahmedabad"],
  ["Outstation Cab Narol GIDC Ahmedabad", "Sedan Cab Narol GIDC Ahmedabad"],
  ["SUV Cab Narol GIDC Ahmedabad", "Company Transport Narol Ahmedabad"],
  ["Employee Mobility Narol GIDC Ahmedabad", "Corporate Fleet Narol GIDC Ahmedabad"],
  ["Staff Pickup Drop Narol GIDC Ahmedabad", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Narol GIDC Ahmedabad",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Narol GIDC Ahmedabad, ensuring smooth and efficient transportation for employees and business executives across the industrial zone."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Narol GIDC and nearby industrial areas, helping employees reach offices, factories, and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our skilled chauffeurs offer safe, courteous, and disciplined travel, ensuring a secure and comfortable commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Narol GIDC."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We provide flexible and tailored corporate cab rental plans to meet the commuting requirements of companies and employees in Narol GIDC Ahmedabad."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team offers round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, providing safe, hygienic, and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is streamlined through our easy booking process and reliable coordination, making employee transport hassle-free."
  }
]

























  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Narol GIDC, Ahmedabad?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and industrial offices in Narol GIDC, Ahmedabad.',
  },
  {
    question: 'What types of corporate transportation services are available in Narol GIDC?',
    answer: 'We provide employee transportation, industrial shuttle services, corporate pickups and drops, airport transfers, and full fleet management solutions for corporate and industrial clients.',
  },
  {
    question: 'Do you support daily employee commute services in Narol GIDC?',
    answer: 'Yes, we offer structured daily commute services with optimized routes, timely pickups, and multi-shift support for employees.',
  },
  {
    question: 'How can companies book corporate cab services in Narol GIDC?',
    answer: 'Bookings can be made via our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate cab services in Narol GIDC?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, tempo travellers, luxury cars, and electric vehicles based on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Narol GIDC?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and comprehensive fleet management.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs for maximum safety.',
  },
  {
    question: 'Do you provide transportation for night shifts and rotational shifts in Narol GIDC?',
    answer: 'Absolutely. We offer reliable transport solutions for night shifts, early morning shifts, weekend operations, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Tejas Desai',
    feedback: 'Reliable corporate cab service for our Narol GIDC office. Drivers are punctual and vehicles are always clean and well-maintained.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Bhavika Shah',
    feedback: 'Professional and efficient service. Our employees are happy with the smooth and timely daily commute services.',
    rating: 5,
  },
];













































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Narol GIDC Ahmedabad",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-narol-gidc.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Narol GIDC Ahmedabad, including employee transport, industrial cab services, corporate shuttle, factory staff transportation, monthly corporate cabs, business cab services, outstation trips, sedan & SUV corporate cabs, staff pickup & drop, and complete corporate fleet solutions.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-narol-gidc-ahmedabad"
  }
};







  return (
    <div>

<Helmet>
  <title>Corporate Cab Service in Narol GIDC Ahmedabad | Employee & Industrial Transport</title>

  <meta
    name="description"
    content="Professional corporate cab services in Narol GIDC Ahmedabad including employee transport, industrial cab services, corporate shuttle, factory staff transportation, monthly corporate cabs, business cab services, outstation trips, sedan & SUV cabs, staff pickup & drop, and complete corporate fleet solutions."
  />

  <meta
    name="keywords"
    content="Narol GIDC Employee Transport Ahmedabad, Corporate Shuttle Narol GIDC Ahmedabad, Industrial Cab Narol GIDC Ahmedabad, Factory Staff Transport Narol Ahmedabad, Monthly Cab Narol GIDC Ahmedabad, Business Cab Narol GIDC Ahmedabad, Affordable Cab Narol GIDC Ahmedabad, Best Corporate Cab Narol GIDC Ahmedabad, Outstation Cab Narol GIDC Ahmedabad, Sedan Cab Narol GIDC Ahmedabad, SUV Cab Narol GIDC Ahmedabad, Company Transport Narol Ahmedabad, Employee Mobility Narol GIDC Ahmedabad, Corporate Fleet Narol GIDC Ahmedabad, Staff Pickup Drop Narol GIDC Ahmedabad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/88.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinnarolgidc;